/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import { Directive, Input, Optional, Host } from "@angular/core";
import { NgControl } from '@angular/forms';
import { ControlContainer } from "@angular/forms";
export class DisableControlDirective {
    /**
     * @param {?} ngControl
     * @param {?} controlContainer
     */
    constructor(ngControl, controlContainer) {
        // debugger
        this.ngControl = ngControl;
        this.controlContainer = controlContainer;
    }
    /**
     * @param {?} condition
     * @return {?}
     */
    set disableControl(condition) {
        setTimeout(() => {
            const /** @type {?} */ action = condition ? 'disable' : 'enable';
            if (this.ngControl) {
                this.ngControl.control[action]();
            }
            if (this.controlContainer) {
                this.controlContainer.control[action]();
            }
        });
    }
}
DisableControlDirective.decorators = [
    { type: Directive, args: [{
                selector: '[disableControl]'
            },] },
];
/** @nocollapse */
DisableControlDirective.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Host },] },
    { type: ControlContainer, decorators: [{ type: Optional }, { type: Host },] },
];
DisableControlDirective.propDecorators = {
    "disableControl": [{ type: Input },],
};
function DisableControlDirective_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    DisableControlDirective.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    DisableControlDirective.ctorParameters;
    /** @type {!Object<string,!Array<{type: !Function, args: (undefined|!Array<?>)}>>} */
    DisableControlDirective.propDecorators;
    /** @type {?} */
    DisableControlDirective.prototype.ngControl;
    /** @type {?} */
    DisableControlDirective.prototype.controlContainer;
}
//# sourceMappingURL=disable-control.directive .js.map